var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompliance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 68,
    viewBox: "0 0 64 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_159_7998)",
    filter: "url(#filter0_d_159_7998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2803 20.7273H34.5283",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2803 28.7273H29.2598",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.28 36.7273H22.6677",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0229 33.8827C38.4036 33.8827 33.8481 38.4381 33.8481 44.0575C33.8481 49.6769 38.4036 54.2323 44.0229 54.2323C49.6423 54.2323 54.1978 49.6769 54.1978 44.0575C54.1978 38.4381 49.6423 33.8827 44.0229 33.8827ZM28.8481 44.0575C28.8481 35.6767 35.6421 28.8827 44.0229 28.8827C52.4038 28.8827 59.1978 35.6767 59.1978 44.0575C59.1978 52.4383 52.4038 59.2323 44.0229 59.2323C35.6421 59.2323 28.8481 52.4383 28.8481 44.0575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0508 45.2134L42.3524 48.515L48.9557 41.9117",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4883 48.6265V8.62646H31.3277L42.9883 20.287V30.3603C43.2952 30.3399 43.6049 30.3296 43.917 30.3296C45.334 30.3296 46.7012 30.5429 47.9883 30.9392V19.2515C47.9883 18.5884 47.7249 17.9525 47.2561 17.4837L34.131 4.3587C33.6622 3.88986 33.0263 3.62646 32.3633 3.62646H9.86328C8.70296 3.62646 7.59016 4.0874 6.76969 4.90787C5.94922 5.72834 5.48828 6.84114 5.48828 8.00146V49.2515C5.48828 50.4118 5.94922 51.5246 6.76969 52.3451C7.59016 53.1655 8.70296 53.6265 9.86328 53.6265H33.8641C32.5274 52.2094 31.4869 50.5097 30.8419 48.6265H10.4883Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_159_7998",
    x: -4,
    y: 0,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_159_7998"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_159_7998",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_159_7998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompliance);
export default __webpack_public_path__ + "static/media/compliance.44d3b90f6ffe99ad53766921bc4298ee.svg";
export { ForwardRef as ReactComponent };